<template>
  <div
    v-on:click="emit('change')"
    :class="{ 'toggle-switch': true, checked: props.checked }"
  >
    <span class="toggle-switch__handle flex items-center justify-center">
      <font-awesome-icon
        v-if="props.checked"
        icon="fa-regular fa-check"
        size="xs"
      />
      <font-awesome-icon
        v-if="!props.checked"
        icon="fa-regular fa-xmark"
        size="xs"
      />
    </span>
  </div>
</template>

<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export type ToggleSwitchProps = {
  checked: boolean;
};

const props = defineProps<ToggleSwitchProps>();
const emit = defineEmits(["change"]);
library.add(faCheck, faXmark);
</script>

<style scoped>
.toggle-switch {
  display: flex;
  position: relative;
  align-items: center;
  border-radius: 12px;
  background-color: #e0e0e0;
  width: 34px;
  height: 20px;
}

.toggle-switch__handle {
  position: absolute;
  left: 50%;
  transform: translateX(-14px);
  transition: transform 0.2s ease-in-out;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  background-color: #fff;
  width: 16px;
  height: 16px;
}

.toggle-switch.checked {
  background-color: var(--border-brand);
}
.toggle-switch.checked .toggle-switch__handle {
  transform: translateX(-2px);
}
</style>
